import { useState } from 'react';
import { useSelector } from 'react-redux';

import { exportBcf } from '../../utils/issue';
import locale from '../../utils/localization.json';
import { IcBCF } from '../../share/icons';
import { infoMessage } from '../../utils/message';

const IssueExportBcf = () => {
    const lang = useSelector((state) => state.language);
    const issues = useSelector((state) => state.issues);
    const { _id, name } = useSelector((state) => state.currentObject);
    const viewer = useSelector((state) => state.viewer);

    const [disabled, setDisabled] = useState(false);

    return (
        <button
            className="absolute top-3 right-7 flex items-center gap-2 text-modelic-gray-400 hover:text-modelic-primary-main text-sm font-medium font-poppins leading-none"
            disabled={disabled}
            onClick={() => {
                setDisabled(true);
                infoMessage(locale[lang].exportInfo);
                exportBcf(viewer, _id, name, issues, setDisabled);
            }}
        >
            {locale[lang].export}
            {IcBCF}
        </button>
    );
};

export default IssueExportBcf;
